export default __webpack_public_path__ + "static/media/bd-logo.d55a22d0.png";